import { useEffect, useState } from "react"
// tags input lib
import "react-tagsinput/react-tagsinput.css"
// phone input lib
import "react-phone-input-2/lib/style.css"
import { toast } from "sonner"
import {
  getAllCities,
  getAllStates,
  getCountries,
} from "../../../Utils/hooks/location"
import { EditContact } from "./EditContact"
import { useGetRequest } from "../../../Utils/hooks/QueryHandler"
import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
import { ContactHeader } from "./ContactModule/ContactHeader"
import { ContactForm } from "./ContactModule/ContactForm"
import { checkTwilioIntegration } from "../../../Utils/helpers/commonhelper"
import GlobalCallModal from './../../ivr/GlobalCallModal';
import TwilioIntegrationForm from './../../ivr/TwilioIntegrationForm';
import { DashboardCards } from "./ContactModule/DashboardCards"

export const Contacts = () => {
  //start column visibility setting
  const columnOptions = [
    { id: "serial", label: "#", mandatory: true },
    { id: "name", label: "Name", mandatory: true },
    { id: "email", label: "Email" },
    { id: "mobile", label: "Mobile" },
    { id: "owner", label: "Owner" },
    { id: "report_to", label: "Report To" },
    { id: "company", label: "Company Name" },
    { id: "designation", label: "Designation" },
    { id: "department", label: "Department" },
    { id: "decision", label: "Decision Maker" },
    { id: "city", label: "City" },
    { id: "state", label: "State" },
    { id: "country", label: "Country" },
    { id: "zipcode", label: "Zipcode" },
    { id: "source", label: "Lead Source" },
    { id: "tags", label: "Tags" },
    { id: "notes", label: "Notes" },
  ]

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visibleContactColumns");
    const allColumns = columnOptions.map(col => col.label);

    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }

    // Default: all columns visible
    return allColumns;
  });

  // state for heading to display
  const lastHeading = localStorage.getItem("last_heading")
  const [heading, setHeading] = useState("All Contacts")

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (filterCategories?.length > 0 && !isInitialized) {
      const lastHeading = localStorage.getItem("last_heading")
      const existingFilter = filterCategories.find(
        (filter) => filter.card_name === lastHeading
      )
      setHeading(existingFilter ? lastHeading : "All Contacts")
      setIsInitialized(true)
    }
  }, [filterCategories, isInitialized])

  // customer data from sesssion storage
  const [customer, setCustomer] = useLocalStorageState("customer")

  // general states 2
  const [showCards, setShowCards] = useState(false)
  // states to store the filter data
  const [filterStates, setFilterState] = useState([])

  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)

  // permission setup for conntacts
  const permission = customer.customer_details?.permission
  const contactPermssion = permission?.filter(c => c.module_name === "contact")
  const user_type = Number(customer.customer_details?.user_type)
  const contactGrants = {
    isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "export")?.is_action)) : true,
  }

  // company permissions while creating contact
  const companyPermission = permission?.filter(c => c.module_name === "company")
  const companyGrants = {
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.create)) : true,
  }
  // for lead source permission
  const leadSourcePermission = permission?.filter(c => c.module_name === "setting")
  const masterGrant = {
    isCreate: user_type !== 1 ? Boolean(Number(leadSourcePermission?.find(c => c.feature_name === "master")?.create)) : true,
  }


  // view state
  // default curr view change to list
  const [currContactView, setCurrContactView] = useLocalStorageState(
    "currContactView",
    "list"
  )
  const [currView, setCurrView] = useState(currContactView || "list")
  const navigate = useNavigate()
  // for offcanvas
  const [show, setShow] = useState(false)
  // country state
  const [country, setCountries] = useState([])
  // all states for filter field hydration
  const [allState, setAllState] = useState([])
  // all cities for filter field hydration
  const [allCity, setAllCity] = useState([])

  // token obj
  const headers = {
    Authorization: customer?.token?.authorization,
    Authentication: customer?.token?.authentication,
  }
  const extras = { customer, setCustomer, rf: headers.Authentication, navigate }
  // all contacts state to pass to the custom fields if field included
  const [allContacts, setAllContacts] = useState([])

  // this dropdownoption was intended here for the mapping logic while fetching the contacts data for the filtercards. That's why i theres no need to attach the 3rd arg of option. I have created it seperately in contactheaders
  const dropdownOptions = [
    { value: "first_name", label: "FirstName" },
    { value: "last_name", label: "LastName" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "owner_id", label: "Owner", },
    { value: "report_to", label: "Report To" },
    { value: "visible_to", label: "Visible To", },
    { value: "company_id", label: "Company Name", },
    { value: "designation", label: "Designation" },
    { value: "department", label: "Department" },
    { value: "decision_maker", label: "Decision Maker" },
    { value: "city", label: "City", },
    { value: "state", label: "State", },
    { value: "country", label: "Country", },
    { value: "zipcode", label: "Zipcode" },
    { value: "lead_source_id", label: "Lead Source", },
    { value: "tag", label: "Tags" },
    { value: "note", label: "Notes" },
  ]


  // endpoint and querykey state for fetching datadata
  const [endpoint, setEndpoint] = useState("")
  const [queryKey, setQueryKey] = useState("")
  // States for using pagination
  const [listLimit, setListLimit] = useState(25)
  const [cardLimit, setCardLimit] = useState(20)

  const [twilioCallClicked,setTwillioCallClicked]=useState(false)
  const [module_id,setModuleId]=useState(null)
  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [callingTo,setCallingTo]=useState(null)
  const limit = currView === "card" ? cardLimit : listLimit
  const setLimit = currView === "card" ? setCardLimit : setListLimit

  const [listOffset, setListOffset] = useState(0)
  const [cardOffset, setCardOffset] = useState(0)

  const activeOffset = currView === "card" ? cardOffset : listOffset
  const setActiveOffset = (value) => {

    currView === "card" ? setCardOffset(value) : setListOffset(value)
  }
  const [search, setSearch] = useState("")

  const params = {
    limit,
    offset: activeOffset,
    search,
  }

  //  allFstate for filter hydration
  const fetchAllStatesData = async () => {
    try {
      const data = await getAllStates()
      if (!data || data === undefined) {
        setAllState([])
        return
      }
      setAllState(
        data.map((state) => ({
          stateName: state.state_name,
          stateCode: state.id,
        }))
      )
    } catch (error) {
      toast.error("Error Fetching State")
      return
    }
  }

  // allcity useeffect for filter hydration
  const fetchAllCitiesData = async () => {
    try {
      const data = await getAllCities()
      if (!data || data === undefined) {
        setAllCity([])
        return
      }
      setAllCity(
        data.map((city) => ({
          cityName: city.city_name,
          cityCode: city.id,
        }))
      )
    } catch (error) {
      toast.error("Error Fetching State")
      return
    }
  }

  // useeffect for country
  const fetchCountriesData = async () => {
    try {
      const data = await getCountries()
      if (!data) return
      setCountries(
        data.map((country) => ({
          countryName: country.name,
          countryId: country.id,
        }))
      )
    } catch (error) {
      toast.error("Error Fetching Data")
      return
    }
  }

  // running all requests parallely
  const initData = async () => {
    await Promise.all([
      fetchCountriesData(),
      fetchAllStatesData(),
      fetchAllCitiesData(),
    ])
  }
  useEffect(() => {
    initData()
  }, [])

  // useeefect for mapping the values and changing the endpoint and query values based on the users custom filter
  useEffect(() => {
    // fetching contacts based on header
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading
    if (lowerHeading === "contacts_created_by_me") {
      setEndpoint(
        `contacts/getContactsCreatedByMe/${customer.customer_details?.id}/${customer.customer_details?.customer_id}/${customer.customer_details?.user_type}`
      )
      setQueryKey("contactsCreatedByMe")
    } else if (lowerHeading === "contacts_created_today") {
      setEndpoint(
        `contacts/getContactsCreatedBasedOnDuration/${customer.customer_details?.id}/${customer.customer_details?.customer_id}/today/${customer.customer_details?.user_type}`
      )
      setQueryKey("contactsCreatedToday")
    } else if (lowerHeading === "contacts_created_this_month") {
      setEndpoint(
        `contacts/getContactsCreatedBasedOnDuration/${customer.customer_details?.id}/${customer.customer_details?.customer_id}/month/${customer.customer_details?.user_type}`
      )
      setQueryKey("contactsCreatedThisMonth")
    } else if (lowerHeading === "all_contacts") {
      setEndpoint(
        `contacts/fetchAllContacts/${customer?.customer_details?.id}/${customer.customer_details?.customer_id}/${customer.customer_details?.user_type}`
      )
      setQueryKey("fetchAllContacts")
    } else {
      const matchedCategory = filterCategories.find((category) => {
        return category.card_name === heading
      })
      if (matchedCategory) {
        setEndpoint(
          `contacts/fetchAllContacts/${customer?.customer_details?.id}/${customer.customer_details?.customer_id}/${customer.customer_details?.user_type}/${matchedCategory.id}`
        )
        setQueryKey(
          `filterQuery${matchedCategory.card_name
            .toLowerCase()
            ?.split(" ")
            .join("_")}`
        )
      }
    }
  }, [heading, filterCategories])

  const { data, error, refetch, isLoading } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    extras,
    params
  )

   const handleGlobalCallChange = () => {
    setGlobalDiller(false);
    setModuleId(null)
    setTwillioCallClicked(false)
  };
  useEffect(() => {
    if(!twilioCallClicked){
      return
    }
  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customer?.customer_details?.customer_id, headers, { customer, setCustomer, rf: headers.Authentication, navigate });
      console.log(res,"saurabh")
      if (res?.status === "fail" || res?.success === false) {
        setShowTwilioModal(true);
      }
      if (res?.status === "success") {
        setGlobalDiller(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsCheckingTwilio(false);
    }
  };
 
  checkTwilio();
}, [twilioCallClicked]);

  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (
      data &&
      data.filter_data &&
      data.filter_data[0] &&
      data.filter_data[0].filter_values
    ) {
      const values = data.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        // Find the corresponding dropdown option to get the display label and potential nested options
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )

        let mappedOptions = null
        if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
          // Replicate the mapping logic from handleAddFilter
          if (dropdownOption.value === "owner_id") {
            mappedOptions = dropdownOption.option.map((opt) => ({
              value: opt.leadId,
              label: opt.leadName,
            }))
          } else if (dropdownOption.value === "lead_source_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.lead_source_id,
              label: opt.source_title,
            }))
          } else if (dropdownOption.value === "company_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.company_id,
              label: opt.company_name,
            }))
          } else if (dropdownOption.value === "country") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.countryId,
              label: opt.countryName,
            }))
          } else if (dropdownOption.value === "state") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.stateCode,
              label: opt.stateName,
            }))
          } else if (dropdownOption.value === "city") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.cityId,
              label: opt.cityName,
            }))
          } else if (dropdownOption.value === "industry") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }))
          } else if (dropdownOption.value === "business_type") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }))
          } else if (dropdownOption.value === "employee_size") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }))
          }
        }
        return {
          id: state.label_name, // IMPORTANT: Generate a new unique ID for React keys
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          option: mappedOptions,
          subFilterType: state.label_query,
          value: state.label_value,
        }
      })
      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }

    if (queryKey === "fetchAllContacts" && data?.data) {
      const contactsData = data.data.map((contact) => ({
        contact_id: contact.id,
        contact_name: contact.contact_full_name,
      }))
      setAllContacts(contactsData)
    }
  }, [queryKey, data])
 

  return (
    <div className="d-flex flex-column mt-4 w-100">
      <ContactHeader
        heading={heading}
        setHeading={setHeading}
        lastHeading={lastHeading}
        showCards={showCards}
        setShowCards={setShowCards}
        setSearch={setSearch}
        currView={currView}
        setActiveOffset={setActiveOffset}
        setCurrView={setCurrView}
        setCurrContactView={setCurrContactView}
        dropdownOptions={dropdownOptions}
        filterStates={filterStates}
        setFilterState={setFilterState}
        filterCategories={filterCategories}
        setFilterCategories={setFilterCategories}
        columnOptions={columnOptions}
        columns={columns}
        setColumns={setColumns}
        contactGrants={contactGrants}
        setShow={setShow}
        country={country}
        allState={allState}
        allCity={allCity}
        setTempFilterData={setTempFilterData}
      />

      <ContactForm
        show={show}
        setShow={setShow}
        companyGrants={companyGrants}
        refetch={refetch}
        country={country}
        allContacts={allContacts}
        masterGrant={masterGrant}
      />

      <DashboardCards
        heading={heading}
        headers={headers}
        extras={extras}
        show={showCards}
      />

      <EditContact
        isInitialized={isInitialized}
        columns={columns}
        limit={limit}
        filterData={tempFilterData}
        totalContacts={data?.total_count}
        setLimit={setLimit}
        currView={currView}
        data={data && data?.data}
        error={error}
        isLoading={isLoading}
        queryKey={queryKey}
        setOffset={setActiveOffset}
        offset={activeOffset}
        headers={headers}
        visibleColumns={columns}
        allContactData={allContacts}
        columnOptions={columnOptions}
        refetch={refetch}
        isViewGrant={contactGrants?.isView}
        isEditGrant={contactGrants?.isEdit}
        isDeleteGrant={contactGrants?.isDelete}
        setTwillioCallClicked={setTwillioCallClicked}
        setModuleId={setModuleId}
        showtwilioModal={showtwilioModal}
        setCallingTo = {setCallingTo}
      ></EditContact>

      {globalDiller && (
          <GlobalCallModal
            isOpen={globalDiller}
            customerId={customer?.customer_details?.customer_id}
            loginUserId={customer?.customer_details?.id}
            phoneNumber={callingTo}
            onClose={handleGlobalCallChange}
            module_name={"contact"}
            module_id={module_id}
          />
        )}
  
        {/* {twilio modal} */}
        {showtwilioModal && (
          <TwilioIntegrationForm
            isOpen={showtwilioModal}
            onClose={() => setShowTwilioModal(false)}
          />
        )}

    </div >
  );
};